module.exports = __webpack_public_path__ + "static/imag-60743f61d84978cf7784b7e16424c538.jpeg";